import React from "react";
import { Form, Checkbox } from "antd";

const { Item } = Form;

const CheckboxItem = ({
  getFieldDecorator,
  formItemLayout,
  checkboxLabel,
  initialValue,
  wrapperCol,
  fieldName,
  className,
  onChange,
  disabled,
  labelCol,
  label,
}) => (
  <Item
    label={label}
    className={`two-rows-label ${className}`}
    labelCol={labelCol ? { span: labelCol } : formItemLayout.labelCol}
    wrapperCol={wrapperCol ? { span: wrapperCol } : formItemLayout.wrapperCol}
  >
    {getFieldDecorator(fieldName, {
      initialValue: initialValue ? true : false,
      valuePropName: "checked",
    })(
      <Checkbox onChange={onChange} disabled={disabled}>
        {checkboxLabel}
      </Checkbox>
    )}
  </Item>
);

export default CheckboxItem;
